<template>
	<div class="booking-receipt__data bookinbar_wrap">

		<h3 v-if="hasPropertyName">{{ this.$store.state.property_name }}</h3>

		<div :class="{'hidden-under-md': total.length}">
			<Dates :unEditable="unEditable" ref="datepicker" @edit="startEditmode"></Dates>
			<GuestRooms :unEditable="unEditable" @edit="startEditmode"></GuestRooms>

			<RateCode :unEditable="unEditable" @edit="startEditmode"></RateCode>

			<transition name="fade">
				<div class="button-holder" v-if="editMode">
					<button class="button red" v-bind:class="{loading: currentlyLoading}" v-bind:disabled="currentlyLoading" v-bind:aria-disabled="currentlyLoading" :aria-label="this.$store.state.language.updateBooking">{{ this.$store.state.language.updateBooking }}</button>
				</div>
			</transition>
			<p class="red comingSoonText" v-if="this.$store.state.comingSoonText" v-html="this.$store.state.comingSoonText"></p>
			<a v-if="$store.state.comingSoon" :href="$store.state.continueButton" class="button outline hidden-under-md">
				{{ this.$store.state.comingSoonButtonText }}
			</a>
			<Button v-if="!$store.state.comingSoon && !editMode" :currentlyLoading=currentlyLoading :active=buttonStateActive />
		</div>

		<Breakdown :breakdownVisible="breakdownVisible || windowWidth < 992" />

		<Total />

		<StickyWidget :active=buttonStateActive @open="openBreakdown"></StickyWidget>
	</div>
</template>

<script>

import Dates from './components/widget/Dates'
import GuestRooms from './components/widget/GuestRooms'
import RateCode from './components/widget/RateCode'
import Button from './components/widget/Button'
import Breakdown from './components/widget/Breakdown'
import Total from './components/widget/Total'
import StickyWidget from '@/components/widget/StickyWidget'
import moment from 'moment/src/moment'

export default {
	name: 'Bookingwidget',
	components: {
		StickyWidget,
		Dates,
		GuestRooms,
		RateCode,
		Button,
		Breakdown,
		Total
	},
	data: function(){
		return {
			hasAttention: false,
			errorClasses: [],
			windowWidth: window.innerWidth,
			breakdownVisible: false,
			formInvalid: true,
		}
	},
	mounted() {

		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		})

		let initData = false

		// set inital dates?!
		if(this.$store.state.arrival && this.$store.state.departure) {
			initData = true
			const arrival = this.$store.state.arrival ? moment(this.$store.state.arrival).format(this.$store.state.dateFormat) : moment().format(this.$store.state.dateFormat)
			const departure = this.$store.state.departure ? moment(this.$store.state.departure).format(this.$store.state.dateFormat) : moment().add(1, 'day').format(this.$store.state.dateFormat)

			this.$store.commit('setArrival', arrival)
			this.$store.commit('setDeparture', departure)
		} else {
			this.$store.dispatch('traveldates', {})
		}

		// initial rate and/or code
		if(this.$store.state.rate_code) {
			initData = true
			const newRate = this.$store.state.rates.filter(rate => rate.code == this.$store.state.rate_code)
			this.$store.commit('setRate', newRate.shift())
		}
		if(this.$store.state.promo_code) {
			initData = true
			this.$store.commit('setPromo', this.$store.state.promo_code)
		}

		// set initial destination
		if(this.$store.state.where) {
			initData = true
			this.$store.dispatch('selectDestination', this.$store.state.where)

			const selectedDestination = [... this.$store.state.destinations].concat(this.$store.state.hotels).filter(dest => dest.id == parseInt(this.$store.state.where))

			// reset availability
			this.$store.commit('setAvailability', {})
			if(selectedDestination.length) {
				this.$store.commit('setDestination', { destination: selectedDestination.shift() })
			}
		}

		if(initData) {
			this.$store.dispatch('loadAvailability')
		}

		// events from the outside
		const toggle = document.querySelector('a[data-target="#booking-receipt"]');
		if(toggle && !toggle.classList.contains('edit-toggle--info')) {
			toggle.addEventListener('click', this.startEditmode)
		}

		const wrap = document.querySelector('#booking-receipt')
		if(wrap) {
			const that = this
			wrap.addEventListener('change:invisible', function(){
				that.currencyPopupOpened = false
			})
		}

		// register validation check on form
		const personalDetailsForm = document.querySelector('main #dataForm');
		const noGuarantee = document.getElementById('no_guarantee');
		if(personalDetailsForm && !noGuarantee){
			window.Parsley.on('field:validated', (e) => {
				if(e.parent.isValid()) this.formInvalid = false
				else this.formInvalid = true
			});
		}
		else {
			this.formInvalid = false
		}

		const checkWidth = () => {
			const that = this;
			try {
				if (!window.citizenm.helpers.isUpToTablet()) {
					that.$nextTick(() => {
						that.$store.commit('setEditmode', false)
					})
				}
			} catch (e){
				that.$store.commit('setEditmode', false)
			}
		}
		if(!window.citizenm){
			document.body.addEventListener('wmx:loaded', checkWidth)
		} else {
			checkWidth()
		}

		//vue:loaded event
		const event = new CustomEvent('vue:loaded');
		this.$root.$el.parentElement.dispatchEvent(event);

	},

	created(){
	},

	computed: {
		unEditable: function (){
			return this.$store.state.unEditable
		},
		hasPropertyName: function(){
			return !!this.$store.state.property_name
		},
		editMode: function() {
			return this.$store.state.editMode
		},
		currentlyLoading: function () {
			return this.$store.state.currentlyLoading
		},
		errorShowTime: function () {
			return this.$store.state.errorShowTime
		},
		buttonStateActive: function(){
			return !this.formInvalid && this.$store.state.continueButtonAvailable
		},
		total: function () {
			return this.$store.state.total
		},
	},

	methods: {
		startEditmode(e) {
			// find toggled element if keyboard navi
			if(e.type == 'keydown' && e.code == 'Enter') {
				let parentFieldset = null;
				for (let i = 0; i < e.path.length; i++) {
					if (parentFieldset) {
						continue
					}
					if (e.path[i].tagName == 'FIELDSET') {
						parentFieldset = e.path[i]
					}
				}
				const inputField = parentFieldset.querySelector('input')
				if (inputField) {
					inputField.focus()
				}
			}

			this.$store.dispatch('enterEditmode')
		},
		openBreakdown() {
			const that = this
			that.$nextTick(function() {
				setTimeout(function(){
					that.breakdownVisible = true
				}, 300)
			})
		},

		onResize(){
			this.windowWidth = window.innerWidth
		},
	},

	watch: {
		windowWidth(newW, oldW){
			if(newW < oldW && newW < 992) {
				this.breakdownVisible = true
			}
			else if (newW > oldW) {
				this.breakdownVisible = false
			}
		}
	}
}
</script>